import React, { useCallback, useState } from 'react';
import { Arrow, useLayer } from 'react-laag';

const PopoverMenu = (props) => {
  const {
    children,
    menu,
    placement,
    possiblePlacements,
    triggerOffset = 10,
    arrowOffset,
    disabled,
    onClose,
    zIndex,
    popupMenuStyle = {},
    autoToggle = true,
    triggerBoundsWidth = false,
    layerClass = '',
    ...other
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [layerContainer, setLayerContainer] = useState(null);

  const close = useCallback(() => {
    if (onClose) onClose(isOpen);
    if (disabled && !isOpen) return;
    setIsOpen(!isOpen);
  }, [disabled, onClose, isOpen, setIsOpen]);

  const { renderLayer, triggerProps, layerProps, arrowProps, triggerBounds } = useLayer({
    isOpen: isOpen,
    placement: placement || 'top-start',
    auto: possiblePlacements !== undefined ? true : !placement,
    possiblePlacements: possiblePlacements,
    arrowOffset: arrowOffset || 40,
    triggerOffset: triggerOffset,
    onOutsideClick: close, // close the menu when the user clicks outside,
    container: layerContainer,
    onParentClose: () => {}
  });

  const style = { overflow: 'auto' };

  if (zIndex) {
    style.zIndex = zIndex;
  }
  if (isOpen) {
    style.maxHeight = window.innerHeight - layerProps.style.top;
  }

  if (triggerBoundsWidth) {
    style.width = triggerBounds?.width || 0;
  }

  return (
    <>
      {renderLayer(
        <div
          {...layerProps}
          style={{ ...layerProps.style, ...style, ...popupMenuStyle }}
          className={'popover-menu ' + (isOpen ? 'show' : 'hide')}
        >
          <Arrow {...arrowProps} size={5} roundness={0} />
          {menu && menu(close, isOpen)}
        </div>
      )}
      {autoToggle ? (
        <div {...triggerProps} {...other} onClick={() => close()}>
          {children(isOpen, close)}
        </div>
      ) : (
        children(isOpen, close, triggerProps)
      )}
      <div className={`popover-menu-layer ${layerClass}`} ref={setLayerContainer}></div>
    </>
  );
};

export default PopoverMenu;
